// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story","5177":"home"}[chunkId] || chunkId) + "-" + {"3093":"8fbc5843e8c59ca8ad30","3180":"6d7e3a9360d54675fbbc","5177":"3fa8158cdb1250bd857b","5824":"ec725401bb8a136bfb61"}[chunkId] + ".css";
};